module.exports = __webpack_public_path__ + "img/viber.e76d0f6d.svg";